import React from 'react'

export const DownloadIcon = (
  <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.27681 8.15181C6.52089 7.90773 6.91661 7.90773 7.16069 8.15181L10 10.9911L12.8393 8.15181C13.0834 7.90773 13.4791 7.90773 13.7232 8.15181C13.9673 8.39589 13.9673 8.79161 13.7232 9.03569L10.4419 12.3169C10.1979 12.561 9.80214 12.561 9.55806 12.3169L6.27681 9.03569C6.03273 8.79161 6.03273 8.39589 6.27681 8.15181Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10 2.5C10.3452 2.5 10.625 2.77982 10.625 3.125V11.875C10.625 12.2202 10.3452 12.5 10 12.5C9.65482 12.5 9.375 12.2202 9.375 11.875V3.125C9.375 2.77982 9.65482 2.5 10 2.5Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.125 11.25C3.47018 11.25 3.75 11.5298 3.75 11.875V16.25H16.25V11.875C16.25 11.5298 16.5298 11.25 16.875 11.25C17.2202 11.25 17.5 11.5298 17.5 11.875V16.25C17.5 16.5815 17.3683 16.8995 17.1339 17.1339C16.8995 17.3683 16.5815 17.5 16.25 17.5H3.75C3.41848 17.5 3.10054 17.3683 2.86612 17.1339C2.6317 16.8995 2.5 16.5815 2.5 16.25V11.875C2.5 11.5298 2.77982 11.25 3.125 11.25Z'
    />
  </svg>
)
